import React, { useState } from "react";
import DocumentsRepeater from "./DocumentsRepeater/DocumentsRepeater";
import FontAwesomeIcon from "../Icon";
import './DocumentGroup.scss';
export const DocumentGroup = ({
  name,
  documents,
  onDeleteDocument,
  onDownload,
  onClick,
  user,
  from,
  defaultExpanded = false,
  useCustomConfirmation
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <div className="document-group">
      <div class="document-group__expanding-header" onClick={()=>setExpanded(!expanded)}>
        <FontAwesomeIcon glyph={expanded?"caret-down":"caret-right"} weight={expanded?"solid":"light"}/>
        <h3>{name}</h3>
      </div>
      {expanded && (
        <div className="document-group__documents">
            <DocumentsRepeater
              {...{
                documents,
                onDeleteDocument,
                onDownload,
                onClick,
                user,
                from,
                useCustomConfirmation
              }}
            />
        </div>
      )}
    </div>
  );
};
